import React from 'react'
import Modal from '../Modal'
import { Row } from 'antd'
import DynamicForm from '../FormElements/DynamicForm/index'
import Button from '../FormElements/Button'
import * as Yup from 'yup';
import DisputeFormEvidencePicker from './disputeFormEvidencePicker'
import { useMutation } from 'react-query'
import { ApiCaller } from '../../config'
import { useDispatch } from 'react-redux'
import { setError, setMessage } from '../../store/common/generalSlice'

let form = {
    name: 'disputeForm',
    formFields: [
        {
            name: 'email',
            type: 'text',
            label: { value: 'Email:' },
            width: { md: 24, sm: 24, xs: 24 },
            placeholder: 'Email',
            classes: '',
            icon: null,
        },
        {
            name: 'details',
            type: 'textarea',
            label: { value: 'Details:' },
            width: { md: 24, sm: 24, xs: 24 },
            component: null,
            placeholder: 'Additional Info / Note',
            classes: '',
            icon: null,
            // autoSize: { minRows: 3, maxRows: 3 }
        },
        {
            name: 'evidence',
            type: 'custom',
            label: { value: 'Supporting Evidence/Attachment*' },
            width: { md: 24, sm: 24, xs: 24 },
            component: <DisputeFormEvidencePicker />,
            classes: '',
            icon: null,
        },
        {
            name: 'disclaimer',
            type: 'custom',
            label: '',
            width: { md: 24, sm: 24, xs: 24 },
            component: <div className='flex flex-col items-start gap-2'><label className='text-[#FF1D6A]'>Disclaimer:
            </label><p>Please note that the booking was made using your card, and any refunds will be processed back to the same card. Thank you for your understanding.</p></div>,
            classes: '',
            icon: null,
        },
    ],
    formValidation: {
        // for services we are handling custom error because over there we are opening a modal to select sub services.
        email: Yup.string().required(),
        details: Yup.string().max(1000).required(),
    }
}

const DisputeForm = ({ isModalOpen, setIsModalOpen, formResponseHandler, bookingId, disputedAgainstId, disputedEmail }) => {

    const submitForm = () => {
        document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    const dispatch = useDispatch();

    const disputeMutation = useMutation(async (data) => {


        let disputedData = {
            bookingId,
            disputedAgainst: disputedAgainstId,
            email: data?.email,
            disputeDetail: data?.details,
            evidence: data?.evidence
        }

        const formData = new FormData();

        for (const [key, value] of Object.entries(disputedData)) {
            formData.append(key, value || "");
        }

        let res = await ApiCaller.post('/dispute', formData);
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message || 'dispute submitted successfully'))
                setIsModalOpen(false)
                // sending a success note to a parent component to get the updated data after getting
                // a success msg.
                formResponseHandler('success')
            },
            onError: (error) => {
                dispatch(setError(error?.response?.data?.error?.message || 'error occured'))
                return
            }
        }
    )

    const handleSubmit = (data) => {
        const { disclaimer, ...restData } = data;
        disputeMutation.mutate(restData)
    }

    return (
        <Modal.Basic
            open={isModalOpen}
            width={400}
            onCancel={() => setIsModalOpen(false)}>
            <Row className='w-full p-5'>
                <h3 className='text-center w-full font-semibold text-[18px]'>Report a Dispute</h3>

                <DynamicForm
                    id="disputeForm"
                    form={form}
                    onSubmit={handleSubmit}
                    editData={{ email: disputedEmail ? disputedEmail : '' }}
                />

                <Button.Basic
                    onClick={submitForm}
                    disabled={false}
                    icon={null}
                    loading={disputeMutation?.isLoading}
                    type="primary"
                    size='medium'
                    text='Submit'
                    className='btn-primary w-full'
                />
            </Row>
        </Modal.Basic>
    )
}

export default DisputeForm